import { Loader2, ArrowDown } from "lucide-react";

type Props = {
  pullDistance: number;
  isRefreshing: boolean;
  isPastThreshold: boolean;
};

export function PullToRefreshIndicator({ pullDistance, isRefreshing, isPastThreshold }: Props) {
  if (pullDistance <= 0 && !isRefreshing) return null;

  return (
    <div
      className="flex items-center justify-center overflow-hidden transition-opacity"
      style={{
        height: pullDistance,
        opacity: Math.min(pullDistance / 40, 1),
      }}
    >
      {isRefreshing ? (
        <Loader2 className="h-5 w-5 text-primary animate-spin" />
      ) : (
        <ArrowDown
          className="h-5 w-5 text-muted-foreground transition-transform duration-200"
          style={{
            transform: isPastThreshold ? "rotate(180deg)" : "rotate(0deg)",
            color: isPastThreshold ? "hsl(var(--primary))" : undefined,
          }}
        />
      )}
    </div>
  );
}
